import * as React from 'react';
import { Box, Typography, Button } from '@mui/material';

function IndividualActions({ larguraDaTela, atualizarTamanhoDaTela, aprovedEvent, eventLocation, eventJustification, postAutoFix }) {

    React.useEffect(() => {
        // Adicionar um ouvinte de evento para o redimensionamento da janela
        window.addEventListener('resize', atualizarTamanhoDaTela);
        // Chamar a função inicialmente para pegar o tamanho da tela no início
        atualizarTamanhoDaTela();
        // Remover o ouvinte de evento quando o componente for desmontado
        return () => {
            window.removeEventListener('resize', atualizarTamanhoDaTela);
        };
    }, []);

    const handleClick = (type) => {
        try {
            const ids = []

            const findIds = eventLocation.map(event => eventLocation.length > 0 ? ids.push(event.id) : null)
            const findIdsJust = eventJustification.map(event => eventJustification.length > 0 ? ids.push(event.id) : null)
            if (ids.length > 0) {
                aprovedEvent(ids, "APROVADO")
            }

        } catch (error) {
            console.log(error)
        }
    }

    return (
        <React.Fragment>
            <Box sx={styles.BoxContent}>
                <Box sx={{ paddingTop: '20px' }}>
                    <Typography sx={larguraDaTela < 1500 ? styles.TitleLargura : styles.Title}>
                        Realize ações em massa para<br /> este colaborador
                    </Typography>
                </Box>
                <Box sx={styles.BoxButton}>
                    <Button sx={styles.ButtonRed} onClick={postAutoFix}>
                        <Typography sx={larguraDaTela < 1500 ? styles.TextButtonLargura : styles.TextButton}>
                            Completar todos os registros ausentes
                        </Typography>
                    </Button>
                    <Button sx={styles.ButtonOrange} onClick={handleClick}>
                        <Typography sx={larguraDaTela < 1500 ? styles.TextButtonLargura : styles.TextButton}>
                            Aprovar todos os pontos fora do local
                        </Typography>
                    </Button>
                    <Button sx={styles.ButtonOrange} onClick={handleClick}>
                        <Typography sx={larguraDaTela < 1500 ? styles.TextButtonLargura : styles.TextButton}>
                            Aprovar todos os pontos com justificativa
                        </Typography>
                    </Button>
                </Box>
            </Box>
        </React.Fragment >
    );
}

export default IndividualActions;

const styles = ({
    BoxContent: {
        width: '35%',
        padding: '15px',
    },
    Title: {
        fontSize: '15px',
        marginLeft: '7px',
        fontFamily: 'Montserrat',
        fontWeight: '500'
    },
    TitleLargura: {
        fontSize: '12px',
        marginLeft: '7px',
        fontFamily: 'Montserrat',
        fontWeight: '500'
    },
    BoxButton: {
        width: '100%',
        paddingTop: '25px',
        paddingBottom: '12px'
    },
    TextButton: {
        fontSize: '13px',
        width: '100%',
        textAlign: 'center',
        paddingLeft: '10px'
    },
    TextButtonLargura: {
        fontSize: '9px',
        width: '100%',
        textAlign: 'center',
        paddingLeft: '10px'
    },
    ButtonRed: {
        backgroundColor: '#e01b38',
        padding: '10px',
        marginTop: '7px',
        borderRadius: '15px',
        color: 'white',
        textTransform: 'none',
        width: '100%',
        fontFamily: 'Montserrat',
        whiteSpace: 'nowrap', // Adicione esta linha
        '&:hover': {
            backgroundColor: '#537ccd',
        },
    }
    ,
    ButtonOrange: {
        backgroundColor: '#ff9801',
        padding: '10px',
        marginTop: '7px',
        borderRadius: '15px',
        color: 'white',
        textTransform: 'none',
        width: '100%',
        fontFamily: 'Montserrat',
        '&:hover': {
            backgroundColor: '#537ccd',
        },
        whiteSpace: 'nowrap', // Adicione esta linha
    }
})